import { FloatLabelDesignTokens } from '@primeuix/themes/aura/floatlabel';

export const floatLabelTokens: FloatLabelDesignTokens = {
  root: {
    color: '{form.field.float.label.color}',
    focusColor: '{form.field.float.label.focus.color}',
    invalidColor: '{form.field.float.label.invalid.color}',
    activeColor: '{form.field.float.label.active.color}',
    transitionDuration: '0.2s',
    positionX: '{form.field.padding.x}',
    positionY: '{form.field.padding.y}',
    fontWeight: '500',
  },
  over: {
    active: {
      top: '-1.25rem',
    },
  },
  in: {
    input: {
      paddingTop: '2.5rem',
      paddingBottom: '{form.field.padding.y}',
    },
    active: {
      top: '{form.field.padding.y}',
    },
  },
  on: {
    borderRadius: '{border.radius.xs}',
    active: {
      background: '{form.field.background}',
      padding: '0 0.125rem',
    },
  },
};
